// import { ref, computed } from "vue";
import { defineStore } from "pinia";
import { adsRewardStatus } from "@/api";

export const useRewardStore = defineStore("reward", {
  state: () =>
    <
      {
        status: {
          isChromeReviewed: boolean;
          isG2Reviewed: boolean;
          isAdsAvailable: boolean;
          isTotalLimited: boolean;
          totalRewardCredits: number;
          isLinkedCrmFollowed: boolean;
          isPostRewarded: boolean;
          finishAllReward: boolean;
          installPlugin: boolean;
          bindAccount: boolean;
          isPostToReedBookRewarded: boolean;
          isFollowReedBookRewarded: boolean;
          ecosystemSidebarEnabled: boolean;
          isYoutubeFollowed: boolean;
        };
        hasClickedAds: boolean;
        taskStatus: {
          chrome: {
            start: number;
          };
          g2: {
            start: number;
          };
          linkedCRM: {
            start: number;
          };
          post: {
            start: number;
          };
          plugin: {
            start: number;
          };
          bindEmail: {
            start: number;
          };
          reedBook: {
            start: number;
          };
          followReedBook: {
            start: number;
          };
          ecosystemSidebar: {
            start: number;
          };
          youtube: {
            start: number;
          };
        };
      }
    >{
      status: {},
      hasClickedAds: false,
      taskStatus: {
        chrome: {
          start: 0,
        },
        g2: {
          start: 0,
        },
        linkedCRM: {
          start: 0,
        },
        post: {
          start: 0,
        },
        plugin: {
          start: 0,
        },
        bindEmail: {
          start: 0,
        },
        reedBook: {
          start: 0,
        },
        followReedBook: {
          start: 0,
        },
        ecosystemSidebar: {
          start: 0,
        },
        youtube: {
          start: 0,
        },
      },
    },
  getters: {
    getters_reward_status: (state) => state.status,
  },
  actions: {
    actionGetRewardStatus() {
      return adsRewardStatus()
        .then((res) => {
          if (res.code === 200) {
            this.status = res.data as any;
            return res;
          }
        })
        .catch((e) => {
          console.error(e);
        });
    },
    actionhasClickedAds(bol: boolean) {
      this.hasClickedAds = bol;
    },
  },
  persist: true,
});
